module.exports = __webpack_public_path__ + "img/V0.50fdf9c7.png";